import {Subscription} from 'rxjs';
import {Component} from '@angular/core';
import {LoadingController, ModalController, NavController, NavParams, Platform} from '@ionic/angular';
import {UiMessagesProvider} from '../../services/ui-messages/ui-messages';
import {WsUtilsProvider} from '../../services/utils-ws/ws-utils';
import {AjaxClientProvider, ErrorConsulta} from '../../services/ajax-client/ajax-client.provider';
import {PostParams} from '../../interfaces/ajax.interface';
import {
  PARAM_FILTRE,
  PARAM_GET_OPERARIS_SELECCIO,
  PARAM_ID_PROJECTE,
  PARAM_ROW_FINAL,
  PARAM_ROW_FINAL_VALUE_OPERARIOS,
  PARAM_ROW_INICI,
  PARAM_STRCONN
} from '../../config/constantes';
import {NetworkProvider} from '../../services/network/network.provider';
import {PersistenciaGeneralProvider} from '../../services/persistencia-configuracion/persistencia-general.provider';
import {SyncProvider} from '../../services/sync/sync.provider';

@Component({
  selector: 'page-parte-operario-add-modal',
  templateUrl: 'parte-operario-add-modal.html',
  styleUrls: ['parte-operario-add-modal.scss'],
})
export class ParteOperarioAddModalPage {



  respuesta = "";
  descripcion = "";

  valorSearch = "";

  rowInici = 1;
  rowFinal = 0;

  idProjecte: number = null;

  //lista que mantendrá los elementos en memoria
  operarios: any = [];
  hayMasElementos = true;
  consultaWSRealizada = false;

  private backButtonListener?: Subscription;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public platform: Platform,
              public _ui: UiMessagesProvider,
              public _wsUtils: WsUtilsProvider,
              private _ajax: AjaxClientProvider,
              private _messages: UiMessagesProvider,
              private loadingCtrl: LoadingController,
              public _np: NetworkProvider,
              public _pg: PersistenciaGeneralProvider,
              public _sync: SyncProvider,
              private modalCtrl: ModalController,
  ) {

    if (navParams.get("respuesta") && navParams.get("respuesta") != "") {
      this.respuesta = navParams.get("respuesta");
    }

    if (navParams.get("descripcion") && navParams.get("descripcion") != "") {
      this.descripcion = navParams.get("descripcion");
    }

    this.getListaOperarios();
  }

  /*** trabajo con el boton atras */
  ionViewDidEnter() {
    this.initializeBackButtonCustomHandler();
  }

  ionViewWillLeave() {
    this.backButtonListener?.unsubscribe()
  }

  async initializeBackButtonCustomHandler(): Promise<void> {
    this.backButtonListener = this.platform.backButton.subscribeWithPriority(101, () => {
      this.modalCtrl.dismiss();
    });
  }

  /*** fin trabajo con el boton atras */

  cerrarConParametros(operario: any) {
    let data: any;
    data = {
      idOperari: operario.id,
      descripcio: operario.descripcio,
      tempsMinuts: null
    }
    this.modalCtrl.dismiss(data);
  }


  cerrarSinParametros() {
    this.modalCtrl.dismiss();
  }

  getListaOperarios() {
    if (!this._pg.workingOffline) {
      this.getProcessListaOperariosOnline();
    } else {
      this.getProcessListaOperariosOffline();
    }
  }

  async getProcessListaOperariosOnline() {
    const loading = await this._messages.showLoading("txDescargandoMateriales");
    const params: PostParams[] = this.getParamsToGetListaOperarios();

    this.descargarOperariosFromServer(PARAM_GET_OPERARIS_SELECCIO, params, true)
      .then((res) => {
        loading.dismiss();
        this.consultaWSRealizada = true;
      })
      .catch(err => {
        // console.error(JSON.stringify(err))
        loading.dismiss();
      });
  }

  async getProcessListaOperariosOffline() {
    const loading = await this._messages.showLoading("txRecuperandoOperarios");

    this._sync.getOperaris(this._pg.proyectoSeleccionado.idProjecte)
      .then(() => {
        loading.dismiss();
        this.operarios = this._sync.localOperaris;
      })
      .catch(err => {
        // console.error(JSON.stringify(err))
        loading.dismiss();
      });
  }

  getParamsToGetListaOperarios() {
    const params: PostParams[] = [];

    //StrConn
    const paramStrConn: PostParams = {
      nombre: PARAM_STRCONN,
      valor: this._wsUtils.getStrConn()
    }
    params.push(paramStrConn);

    //rowInici
    const paramRowInici: PostParams = {
      nombre: PARAM_ROW_INICI,
      valor: String(this.rowInici)
    }
    params.push(paramRowInici);

    //rowFinal
    this.rowFinal = this.rowFinal > 0 ? this.rowFinal : PARAM_ROW_FINAL_VALUE_OPERARIOS;
    const paramRowFinal: PostParams = {
      nombre: PARAM_ROW_FINAL,
      valor: String(this.rowFinal)
    }
    params.push(paramRowFinal);

    //idProjecte
    this.idProjecte = this._pg.proyectoSeleccionado.idProjecte;
    const paramIdProjecte: PostParams = {
      nombre: PARAM_ID_PROJECTE,
      valor: String(this.idProjecte)
    }
    params.push(paramIdProjecte);

    //filtre
    if (this.valorSearch && this.valorSearch != '') {
      const paramFiltre: PostParams = {
        nombre: PARAM_FILTRE,
        valor: this.valorSearch
      }
      params.push(paramFiltre);
    }
    return params;
  }

  descargarOperariosFromServer(paramAccion: string, params: PostParams[], primeraBusqueda: boolean) {
    const promesa = new Promise((resolve, reject) => {

      if (primeraBusqueda) {
        this.rowInici = 1;
        this.rowFinal = PARAM_ROW_FINAL_VALUE_OPERARIOS;
        this.operarios = [];
      }
      this._ajax.consultarWS(paramAccion, params, 0)
        .subscribe((res: any) => {
            if (res.operaris.length > 0) {
              this.operarios.push(...res.operaris);
              this.rowInici += PARAM_ROW_FINAL_VALUE_OPERARIOS;
              this.rowFinal += PARAM_ROW_FINAL_VALUE_OPERARIOS;

              resolve(true);
            } else {
              resolve(false);
            }
          },
          (errConsulta: ErrorConsulta) => {
            this._messages.showToastDefault(errConsulta.mensaje);
            // console.error("ERROR: " + errConsulta.categoria + " " + errConsulta.categoria);
            resolve(false);
          });
    })
      .catch(err => {
        // console.error("error en descargarOperariosFromServer: " + JSON.stringify(err, Object.getOwnPropertyNames(err)));
      });
    return promesa;
  }


  doInfinite(infiniteScroll) {
    if (!this._pg.workingOffline) {
      // console.log('Begin async operation');
      this.descargarOperariosFromServer(PARAM_GET_OPERARIS_SELECCIO, this.getParamsToGetListaOperarios(), false)
        .then((hayMas: boolean) => {
          this.hayMasElementos = hayMas;
          // console.log('Async operation has ended');
          infiniteScroll.target.complete();
        });
    } else {
      // console.log('Begin async operation offline');
      this.hayMasElementos = false;
      // console.log('Async operation has ended offline');
      infiniteScroll.target.complete();
    }
  }

  onInput(ev: any) {
    this.rowInici = 1;
    this.rowFinal = PARAM_ROW_FINAL_VALUE_OPERARIOS,
      this.getListaOperarios();
  }
}
